module.exports = __webpack_public_path__ + "assets/2-Chicago-Tech-Industry-Sales-Recruiters.c6eb2802.png";